import * as constants from './constants';
import abbr from '../../../config/abbr';
import { message } from 'antd';
import {
	apiGetVideoUrl,
	apiVideoFindCourseDetail,
	apiVideoFindTeacher,
	apiVideoFindComment,
	apiVideoAddComment,
	apiGetClassVideoQs,
	apiVideoSearchNote,
	apiVideoAddNote,
	apiAskQuestions,
	apiVideoAddRecord,
	apiTimeNow,
	apisigncode
} from '../../../config/index';
import {getPhonePyzm, toggleSending} from "../../manu/register/store/actionCreators";

export const setVideoId = (id) => ({
	type: constants.SET_VIDEO_ID,
	id
})

const setVideoUrl = (url) => ({
	type: constants.SET_VIDEO_URL,
	url
})

const setVideoStudyTime = (time) => ({
	type: constants.SET_VIDEO_STUDY_TIME,
	time
})

const setVideoLookTime = (time) => ({
	type: constants.SET_VIDEO_LOOK_TIME,
	time
})
const setVideolastCreateTime = (time) => ({
	type: constants.SET_VIDEO_lASTCREATE_TIME,
	time
})
const setVideolastStudyTime = (time) => ({
	type: constants.SET_VIDEO_lASTSTUDY_TIME,
	time
})
const setCourseInfo = (data) => ({
	type: constants.SET_COURSE_INFO,
	data
})

const setTeacherInfo = (data) => ({
	type: constants.SET_TEACHER_INFO,
	data
})

const setTeacherArea = (data) => ({
	type: constants.SET_TEACHER_AREA,
	data
})

const setCommentList = (total, data) => ({
	type: constants.SET_COMMENT_LIST,
	total, data
})

export const setCommentLoader = (value) => ({
	type: constants.SET_COMMENT_LOADER,
	value
})

export const getVideoDetail = (id,gradeId) => {
	let formData = {
		classId: id,
		gradeId: gradeId
	}
	return (dispatch) => {
		// 设置video链接

		apiGetVideoUrl(formData).then(response => {
			if (response.code === abbr.okId) {
				dispatch(setVideoUrl(response.data.classDetail.classHdUrl));
				dispatch(setVideoStudyTime(response.data.studyTime));
				dispatch(setVideoLookTime(response.data.lookTime));
				localStorage.removeItem("lastCreateTime",'');
				localStorage.removeItem("lastStudyTime",'');
				localStorage.setItem("lastCreateTime",'');
				localStorage.setItem("lastStudyTime",'');
				let formData2 = {
					tchId: response.data.classDetail.tchId
				}
				// 设置老师信息
				apiVideoFindTeacher(formData2).then(response => {
					if (response.code === abbr.okId) {
						dispatch(setTeacherInfo(response.data));
						var area = response.data.tchLessons.split(';');
						dispatch(setTeacherArea(area));
					}else{
						
					}
				}).catch(error => {
					console.log(error);
				})
				// 获取老师评价
				dispatch(setCommentListByPage(1, response.data.classDetail.tchId));
				// 获取名师答疑
				dispatch(setSolveListByPage(1, id));
				// 设置笔记列表
				dispatch(getNoteList(1, 10, id));
			}else{
				
			}
		}).catch(error => {
			console.log(error);
		})
		// 设置课程信息
		apiVideoFindCourseDetail(formData).then(response => {
			if (response.code === abbr.okId) {
				dispatch(setCourseInfo(response.data));
			}else{
				
			}
		}).catch(error => {
			console.log(error);
		})
	}
}

export const saveVideoRecord = (id, lookTime, studyTime,gradeId) => {
	return (dispatch) => {
		dispatch(setVideoLookTime(lookTime));
		dispatch(setVideoStudyTime(studyTime));
		let userObj = localStorage.getItem('userObj');
		let time= localStorage.getItem(id+"startTimes");// new Date().getTime()
		let logs=`[{"stuId":${JSON.parse(userObj).stuId},"classId":${id},"gradeId":${gradeId},"startTime":${time},"isOnline":1,"isOnLine":1}]`;

		let formData = {
			"logs": logs,
			"lookTime": lookTime,
			"studyTime": studyTime,
			//"lastCreateTime":localStorage.getItem('lastCreateTime'),
			//"lastStudyTime":localStorage.getItem('lastStudyTime'),
			"type":1
		}
		// 添加听课记录
		apiVideoAddRecord(formData).then(response => {
			if(response.code==0){
				localStorage.setItem(id+'startTimes', response.data[0].time);
				//localStorage.setItem('lastCreateTime', response.data.lastCreateTime);
				//localStorage.setItem('lastStudyTime', response.data.lastStudyTime);
			}
		}).catch(error => {
		  console.log(error)
		})
	}
}

export const setTimeNow = (id)=> {
	return (dispatch) => {
		// 获取线上时间
		apiTimeNow({}).then(response => {
			if (response.code === abbr.okId) {
				localStorage.setItem(id+'startTimes', response.data.timestamp);
				console.log(response.data.timestamp);
			}
		}).catch(error => {
			console.log(error)
		})
	}
}
export const setCommentListByPage = (page, id) => {
	let formData = {
		page: page,
		pagesize: 10,
		tchId: id
	}
	return (dispatch) => {
		// 获取老师评价
		apiVideoFindComment(formData).then(response => {
			if (response.code === abbr.okId) {
				dispatch(setCommentList(response.data.total, response.data.list));
			}else{
				dispatch(setCommentList(null, []));
			}
			dispatch(setCommentLoader(false));
		}).catch(error => {
			console.log(error);
		})
	}
}

export const setCommentPage = (value) => ({
	type: constants.SET_COMMENT_PAGE,
	value
})

export const addComment = (comment, rate, tchId) => {
	let formData = {
		score: rate,
		content: comment,
		tchId: tchId,
	};
	return (dispatch) => {
		apiVideoAddComment(formData).then(response => {
			if(response.code === abbr.okId){
				message.success(response.msg);
				dispatch(setCommentListByPage(1, tchId));
				dispatch(setCommentPage(1));
			}else{
				message.error(response.msg);
			}
			dispatch(handleCommentTextareaChange(''));
		}).catch(error => {
			
		})
	}
}

export const changeTab = (value) => ({
	type: constants.CHANGE_TAB,
	value
})

export const handleCommentTextareaChange = (value) => ({
	type: constants.HANDLE_COMMENT_TEXTAREA_CHANGE,
	value
})

export const handleRateChange = (value) => ({
	type: constants.HANDLE_RATE_CHANGE,
	value
})

export const handleQuillChange = (value) => ({
	type: constants.HANDLE_QUILL_CHANGE,
	value
})

export const handleAskQuestionInputChange = (value) => ({
	type: constants.HANDLE_ASK_QUESTION_INPUT_CHANGE,
	value
})

export const setSolveLoader = (value) => ({
	type: constants.SET_SOLVE_LOADER,
	value
})

const setSolveList = (total, data) => ({
	type: constants.SET_SOLVE_LIST,
	total, data
})

export const setSolveListByPage = (page, id) => {
	let formData = {
		"classId": id,
		"page": page,
		"pagesize": 10,
	}
	return (dispatch) => {
		apiGetClassVideoQs(formData).then(response => {
			if(response.code === abbr.okId){
				dispatch(setSolveList(response.data.total, response.data.list));
			}else{
				dispatch(setSolveList(null, []));
			}
			dispatch(setSolveLoader(false));
		}).catch(error => {
			
		})
	}
}

export const setSolvePage = (value) => ({
	type: constants.SET_SOLVE_PAGE,
	value
})

export const submitAsk = (gradeId,title, desc, id) => {
	let formData = {
		classId: id,
		gradeId:gradeId,
		questionTitle: title,
		questionContent: desc,
	}
	return (dispatch) => {
		apiAskQuestions(formData).then(response => {
			if(response.code === abbr.okId){
				dispatch(setSolveList(response.data.total, response.data.list));
			}else{
				dispatch(setSolveList(null, []));
			}
			dispatch(setSolveLoader(false));
		}).catch(error => {
			
		})
	}
}

const setNoteList = (total, data) => ({
	type: constants.SET_NOTE_LIST,
	total, data
})

export const setNoteLoader = (value) => ({
	type: constants.SET_NOTE_LOADER,
	value
})

export const getNoteList = (page, pagesize, id) => {
	let formData = {
		classId: id,
		page: page,
		pagesize: pagesize
	}
	return (dispatch) => {
		apiVideoSearchNote(formData).then(response => {
			if(response.code === abbr.okId){
				dispatch(setNoteList(response.data.total, response.data.list));
			}else{
				dispatch(setNoteList(null, []));
			}
			dispatch(setNoteLoader(false));
		}).catch(error => {
			
		})
	}
}

export const handleNoteTextareaChange = (value) => ({
	type: constants.HANDLE_NOTE_TEXTAREA_CHANGE,
	value
})

export const setNotePage = (value) => ({
	type: constants.SET_NOTE_PAGE,
	value
})

export const addNote = (desc, id, time) => {
	let formData = {
		classId: id,
		noteContent: desc,
		noteVideotime: time
	}
	return (dispatch) => {
		apiVideoAddNote(formData).then(response => {
			if(response.code === abbr.okId){
				dispatch(setNoteLoader(true));
				dispatch(getNoteList(1, 10, id));
				dispatch(setNotePage(1));
				message.success(response.msg);
			}else{
				message.error(response.msg);
			}
			dispatch(handleNoteTextareaChange(''));
		}).catch(error => {
			
		})
	}
}

